import { has } from 'lodash-es';
export function safeBooleanProps(props, propNames) {
  propNames.forEach(function (name) {
    if (has(props, name) && (props[name] === 'true' || props[name] === 'false')) {
      props[name] = props[name] === 'true';
    }
  });
}